<template>
  <div id="app">
    <router-view/>
    <popup/>
  </div>
</template>

<script>
import $ from 'jquery'
import popup from '@/components/Popup/popup'
export default {
  name: 'App',
  components:{
    popup,
  },
  mounted () {
    this.common.panduan();
    if (window.history && window.history.pushState) {
        // 向历史记录中插入了当前页
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods:{
    goBack () {
        // console.log("点击了浏览器的返回按钮");
        sessionStorage.clear();
        location.reload();
        history.pushState(null, null, document.URL);
    },
  }
}
</script>

<style lang='less'>
#app{
  user-select:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue